"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var browser_entry_1 = require("@cian/http-client/lib/browser-entry");
var settings_1 = require("@cian/http-client/lib/shared/circuit_breaker/settings");
var utils_1 = require("@cian/utils");
var v1 = require("uuid/v1");
var http_client_1 = require("../shared/http_client");
var circuitBreakerHashs = new WeakMap();
function getCircuitBreakerHash(config) {
    var hash = circuitBreakerHashs.get(config);
    if (!hash) {
        hash = v1();
        circuitBreakerHashs.set(config, hash);
    }
    return hash;
}
exports.telemetry = {
    clientName: 'cian-v16-frontend',
    // tslint:disable-next-line:variable-name
    increment: function (_name, _value) { },
    normalizeHost: utils_1.normalizeHost,
    serverName: 'undefined',
    // tslint:disable-next-line:variable-name
    timer: function (_name, _timeDelta) { },
};
exports.httpClient = browser_entry_1.createDefaultClient({
    assertStatusCode: http_client_1.assertStatusCode,
    circuitBreaker: tslib_1.__assign({}, settings_1.defaultCircuitBreakerSettings, { hashFunction: getCircuitBreakerHash }),
    telemetry: exports.telemetry,
    timeout: 30000,
});



//////////////////
// WEBPACK FOOTER
// ./src/browser/http_client.ts
// module id = 46
// module chunks = 2